import { LookupFieldValue } from "@smartsuite/types";
import { FieldRegistryConfig } from "../../types";
import { LookupFieldControl } from "./LookupFieldControl/LookupFieldControl";
import { defaultToReviewString } from "../review/reviewString.helpers";

/** Lookup field value in form state: nested array of looked-up values used for conditional logic; not submitted. */
export type LookupFormValue = LookupFieldValue | null;

export const lookupFieldConfig: FieldRegistryConfig<LookupFormValue> = {
  icon: "lookup",
  control: LookupFieldControl,
  // No convertFormValueToApi - Lookup values are excluded from submission in converter.
  toReviewString: defaultToReviewString,
};
